// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"SearchInput_inputContainer__1IGKZ","input":"SearchInput_input__3ElsI","inputIcon":"SearchInput_inputIcon__cRkl-"};